/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 16:20:35
 * @LastEditors: linxi
 * @LastEditTime: 2023-11-10 13:16:31
 */
import { Space, Switch, TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { selectTenantCategory } from '../../../../app/applicationSlice'
import { useSelector } from 'react-redux'

type ActionType = 'edit' | 'stateEdit'

export const columns = (
  flag: any,
  tenantCategory: number,
  startIndex: number
): TableColumnType<any>[] => {

  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '5rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '库房名称',
      dataIndex: 'storehouseName',
      align: 'center',
      ellipsis: true,
      width: '8rem',
      render: (_, r) => {
        return r.storehouseName ? r.storehouseName : '-'
      },
    },
    {
      title: '批次',
      dataIndex: 'batchNo',
      align: 'center',
      ellipsis: true,
      width: '5rem',
      render: (_, r) => {
        return r.batchNo ? r.batchNo : '-'
      },
    },
    {
      // 商品名称/生产厂家/规格/剂型
      title: '产品信息',
      align: 'left',
      width: '300px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div style={{ height: '55px' }}>
            <p
              style={{
                height: '28px',
                lineHeight: '36px',
                padding: '0',
                margin: '0',
                fontSize: '16px',
                fontWeight: 'bolder',
              }}
            >
              {t.name}
            </p>
            <p
              style={{
                height: '28px',
                lineHeight: '24px',
                padding: '0',
                margin: '0',
                color: '#999999',
                fontSize: '14px',
              }}
            >
              {t.productInfo}
            </p>
          </div>
        )
      },
    },
    {
      title: '入库单价',
      dataIndex: 'unitPrice',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return flag == 1 ? '-' : r.unitPrice ? r.unitPrice?.toFixed(5) : '0'
      },
    },
    {
      title: '期初数量',
      dataIndex: 'beginningCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r?.beginningCount + r?.accountUnit}</span>
            <span>/{r.splitBeginningCount + r?.splitUnit} </span>
          </div>
        ) : (
          <div>
            <span>{r?.beginningCount + r?.accountUnit}</span>
          </div>
        )
      },
    },
    {
      title: '购入入库',
      dataIndex: 'storageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return   r.storageCount + r?.accountUnit
        
      },
    },
    {
      title: '购入退库',
      dataIndex: 'returnStorageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return   r.returnStorageCount + r?.accountUnit
      },
    },
    {
      title: '发药',
      dataIndex: '',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.shipmentsCount + r?.accountUnit} </span>
            <span>/{r?.shipmentsSplitCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.shipmentsCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
    {
      title: '退药',
      dataIndex: 'realPayAmount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.returnShipmentsCount + r?.accountUnit} </span>
            <span>/{r?.returnShipmentsSplitCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.returnShipmentsCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
    {
      title: '领用出库',
      dataIndex: 'obtainCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => {
        return r.obtainCount + r?.accountUnit
      },
    },
    {
      title: '调拨',
      dataIndex: 'allocationCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => {
        return  r.allocationCount + r?.accountUnit
      },
    },
    {
      title: '借记',
      dataIndex: 'borrowCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => {
        return r.borrowCount + r?.accountUnit
      },
    },
    {
      title: '库存盘点',
      dataIndex: '',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.auditCount + r?.accountUnit} </span>
            <span>/{r?.auditSplitCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.auditCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
    {
      title: '报损',
      dataIndex: 'damageCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => {
        return  r.damageCount + r?.accountUnit
      },
    },
    {
      title: '连锁调拨',
      dataIndex: 'chainStockOut',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.chainStockOut + r.accountUnit,
    },
    {
      title: '采购',
      dataIndex: 'chainBuyStockIn',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.chainBuyStockIn + r.accountUnit,
    },
    {
      title: '其他出库',
      dataIndex: '',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.otherReturnStorageCount + r?.accountUnit} </span>
            <span>/{r?.otherReturnStorageSplitCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.otherReturnStorageCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
    {
      title: '其他入库',
      dataIndex: '',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.otherStorageCount + r?.accountUnit} </span>
            <span>/{r?.otherStorageSplitCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.otherStorageCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
    {
      title: '结存数量',
      dataIndex: '',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return r?.splitTag == '1' ? (
          <div>
            <span>{r.closeCount + r?.accountUnit} </span>
            <span>/{r?.splitCloseCount + r?.splitUnit}</span>
          </div>
        ) : (
          <div>
            <span>{r.closeCount + r?.accountUnit} </span>
          </div>
        )
      },
    },
  ]
  return flag == 1 
    ? tenantCategory == 17 
      ? columns.filter((v: any) => 
        ['序号', '库房名称', '产品信息', '入库单价', '期初数量', '报损',
          '购入入库', '领用出库', '结存数量'].includes(v.title)) 
      : columns.filter((v) => v.title !== '批次') 
    : tenantCategory == 17 
      ? columns?.filter((v: any) => 
        ['序号', '库房名称', '批次', '产品信息', '入库单价', '报损',
          '期初数量', '购入入库', '领用出库', '结存数量'].includes(v.title))
      : columns
}



export const columnsWithAmount = (
  flag: any,
  tenantCategory: number,
  startIndex: number
): TableColumnType<any>[] => {

  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '5rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '库房名称',
      dataIndex: 'storehouseName',
      align: 'center',
      ellipsis: true,
      width: '8rem',
      render: (_, r) => {
        return r.storehouseName ? r.storehouseName : '-'
      },
    },
    {
      title: '批次',
      dataIndex: 'batchNo',
      align: 'center',
      ellipsis: true,
      width: '5rem',
      render: (_, r) => {
        return r.batchNo ? r.batchNo : '-'
      },
    },
    {
      // 商品名称/生产厂家/规格/剂型
      title: '产品信息',
      align: 'left',
      width: '300px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div style={{ height: '55px' }}>
            <p
              style={{
                height: '28px',
                lineHeight: '36px',
                padding: '0',
                margin: '0',
                fontSize: '16px',
                fontWeight: 'bolder',
              }}
            >
              {t.name}
            </p>
            <p
              style={{
                height: '28px',
                lineHeight: '24px',
                padding: '0',
                margin: '0',
                color: '#999999',
                fontSize: '14px',
              }}
            >
              {t.productInfo}
            </p>
          </div>
        )
      },
    },
    {
      title: '入库单价',
      dataIndex: 'unitPrice',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => flag == 1 ? '-' : (r.unitPrice?.toFixed(5) || '0'),
    },
    {
      title: '期初数量',
      dataIndex: 'beginningCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
         return (<div>
            <span>{r.beginningCount + r.accountUnit}</span>
            {r?.splitTag == '1' && <span>/{r.splitBeginningCount + r.splitUnit}</span>}
          </div>)
      }
    },
    {
      title: '购入入库',
      dataIndex: 'storageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.storageCount + r.accountUnit,
    },
    {
      title: '入库金额',
      dataIndex: 'n1',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => flag == 1 ? '-' : (r.storageCount ? (r.storageCount * r.unitPrice).toFixed(2) : '0.00'),
    },
    {
      title: '购入退库',
      dataIndex: 'returnStorageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.returnStorageCount + r.accountUnit,
    },
    {
      title: '退库金额',
      dataIndex: 'n2',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => flag == 1 ? '-' : (r.returnStorageCount ? (r.returnStorageCount * r.unitPrice).toFixed(2) : '0.00'),
    },
    {
      title: '发药',
      dataIndex: 'shipmentsCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return (<div>
          <span>{r.shipmentsCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.shipmentsSplitCount + r.splitUnit}</span>}
        </div>)
      }
    },
    {
      title: '发药金额',
      dataIndex: 'n3',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.shipmentsCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.shipmentsSplitCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }

      },
    },
    {
      title: '退药',
      dataIndex: 'returnShipmentsCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return (<div>
          <span>{r.returnShipmentsCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.returnShipmentsSplitCount + r.splitUnit}</span>}
        </div> )
      }
    },
    {
      title: '退药金额',
      dataIndex: 'n4',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.returnShipmentsCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.returnShipmentsSplitCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }

      },
      ellipsis: true
    },
    {
      title: '领用出库',
      dataIndex: 'obtainCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.obtainCount + r.accountUnit,
    },
    {
      title: '领用出库金额',
      dataIndex: 'n4',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.obtainCount || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }
      },
      ellipsis: true
    },
    {
      title: '调拨',
      dataIndex: 'allocationCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => r.allocationCount + r.accountUnit,
    },
    {
      title: '调拨金额',
      dataIndex: 'n4',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.allocationCount || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }
      },
      ellipsis: true
    },
    {
      title: '借记',
      dataIndex: 'borrowCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => r.borrowCount + r.accountUnit,
    },
    {
      title: '借记金额',
      dataIndex: 'n4',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.borrowCount || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }
      },
      ellipsis: true
    },
    {
      title: '库存盘点',
      dataIndex: 'auditCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return (<div>
          <span>{r.auditCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.auditSplitCount + r.splitUnit}</span>}
        </div>)
      },
    },
    {
      title: '盘点金额',
      dataIndex: 'n5',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.auditCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.auditSplitCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }
      },
      ellipsis: true
    },
    {
      title: '报损',
      dataIndex: 'damageCount',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, r) => r.damageCount + r.accountUnit,
    },
    {
      title: '报损金额',
      dataIndex: 'n5',
      align: 'center',
      width: '6rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.damageCount || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }
      },
      ellipsis: true
    },
    {
      title: '连锁调拨',
      dataIndex: 'chainStockOut',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.chainStockOut + r.accountUnit,
    },
    {
      title: '连锁调拨金额',
      dataIndex: 'n10',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.chainStockOut || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }

      },
      ellipsis: true
    },
    {
      title: '采购',
      dataIndex: 'chainBuyStockIn',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.chainBuyStockIn + r.accountUnit,
    },
    {
      title: '采购金额',
      dataIndex: 'n11',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          return (<span>{((r.chainBuyStockIn || 0) * (r.unitPrice || 0)).toFixed(2)}</span>)
        }

      },
      ellipsis: true
    },
    {
      title: '其他出库',
      dataIndex: 'otherReturnStorageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return ( <div>
          <span>{r.otherReturnStorageCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.otherReturnStorageSplitCount + r.splitUnit}</span>}
        </div>)

      },
    },
    {
      title: '其他出库金额',
      dataIndex: 'n9',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.otherReturnStorageCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.otherReturnStorageSplitCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }

      },
      ellipsis: true
    },
    {
      title: '其他入库',
      dataIndex: 'otherStorageCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return ( <div>
          <span>{r.otherStorageCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.otherStorageSplitCount + r.splitUnit}</span>}
        </div>)

      },
    },
    {
      title: '其他入库金额',
      dataIndex: 'n6',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.otherStorageCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.otherStorageSplitCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }
      },
      ellipsis: true
    },
    {
      title: '结存数量',
      dataIndex: 'closeCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, r) {
        return ( <div>
          <span>{r.closeCount + r.accountUnit}</span>
          {r?.splitTag == '1' && <span>/{r.splitCloseCount + r.splitUnit}</span>}
        </div>)

      },
    },
    {
      title: '结存金额',
      dataIndex: 'n7',
      align: 'center',
      width: '8rem',
      render: function Element(_, r) {
        if(flag == 1){
          return <span>-</span>;
        }else{
          const mainAmount = (r.closeCount || 0) * (r.unitPrice || 0);
          const splitAmount = (r?.splitCloseCount || 0) * (r.unitPrice || 0) / (r.splitScale || 1);
          return <span>{(mainAmount + splitAmount).toFixed(2)}</span>;
        }
      },
      ellipsis: true
    },
  ]
  return flag == 1 
    ? tenantCategory == 17 
      ? columns.filter((v: any) => 
        ['序号', '库房名称', '产品信息', '入库单价', '期初数量', 
          '购入入库', '入库金额', '领用出库', '领用出库金额', 
          '报损', '报损金额', '结存数量', '结存金额'].includes(v.title)) 
      : columns.filter((v) => v.title !== '批次') 
    : tenantCategory == 17 
      ? columns?.filter((v: any) => 
        ['序号', '库房名称', '批次', '产品信息', '入库单价', 
          '期初数量', '购入入库', '入库金额', '领用出库', 
          '领用出库金额', '报损', '报损金额', '结存数量', '结存金额'].includes(v.title))
      : columns
}